import { render } from "./TableBillsClient.vue?vue&type=template&id=20845703&scoped=true"
import script from "./TableBillsClient.vue?vue&type=script&lang=js"
export * from "./TableBillsClient.vue?vue&type=script&lang=js"

import "./TableBillsClient.vue?vue&type=style&index=0&id=20845703&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20845703"]])

export default __exports__